<script>
// SelectTool — consulta por punto implícita. QA-204 eliminó la herramienta
// "Consulta" del menú y del catálogo: el clic sobre una capa activa muestra el
// popup de atributos sin abrir ninguna herramienta. Este componente queda
// montado sin UI (ToolContainer.vue) solo para sostener ese comportamiento:
// sincroniza selectService con las capas activas y respeta la prioridad de
// interacción (Dibujar, Geoproceso o Anotaciones lo callan vía
// mapInteractionTool). Los modos Polígono/Círculo murieron con el panel.
import { vuex } from '@/components/mixin/vuex.js'
import { selectService } from '@/services/map/selectService.js'
import { mapService } from '@/services/map/mapService.js'

export default {
  name: 'SelectTool',
  mixins: [vuex],
  computed: {
    // Capas WMS agregadas por URL durante la sesión (no persistidas),
    // excluyendo las que el usuario ocultó con el checkbox de visibilidad (no
    // deben responder a la consulta si no están en el mapa)
    wmsSessionLayers() {
      return this.$store.getters.getWmsSessionLayers.filter(layer => layer.visible !== false)
    },
    // Capas de un resultado de geoproceso agregadas al mapa (no activadas
    // por el usuario en Lista de Capas, ver GeoprocessingChart.vue)
    geoprocessResultLayers() {
      return this.$store.getters.getGeoprocessResultLayers
    },
    // Capas persistidas + capas WMS de sesión + capas de resultado de
    // geoproceso: el conjunto completo que la herramienta "Consulta" debe
    // poder consultar con GetFeatureInfo
    // Capas persistidas + capas WMS de sesión: el conjunto completo que la
    // consulta puede resolver con GetFeatureInfo
    combinedActiveLayers() {
      return [...this.activeLayers, ...this.wmsSessionLayers, ...this.geoprocessResultLayers]
    }
  },
  watch: {
    activeLayers() {
      this.syncSelectService()
    },
    // Agregar/quitar una capa WMS de sesión también activa la consulta por
    // punto implícitamente, igual que las capas persistidas.
    wmsSessionLayers() {
      this.syncSelectService()
    },
    // Ídem para las capas agregadas por un resultado de geoproceso
    geoprocessResultLayers() {
      this.syncSelectService();
    },
    // La prioridad de interacción cambió: Consulta se calla si manda otra de
    // las cuatro. El caso '' NO desactiva: hidePanel() (Select.vue:171-178)
    // hace soft-close a propósito dejando vivos listener, popup y cursor.
    // La consulta se calla si manda otra de las herramientas de interacción;
    // al recuperar el mando solo se re-arma si quedan capas consultables.
    mapInteractionTool(tool) {
      if (tool && tool !== 'select') {
        selectService.disable()
        return
      }
      if (this.combinedActiveLayers.length === 0) return
      this.syncSelectService()
    }
  },
  mounted() {
    this.syncSelectService()
  },
  beforeDestroy() {
    selectService.disable()
  },
  methods: {
    // Sincroniza el servicio con el conjunto combinado de capas: enciende la
    // consulta por punto si no está corriendo, sincroniza capas si ya corre,
    // o apaga el servicio cuando no queda ninguna capa.
    syncSelectService() {
      const owner = this.mapInteractionTool
      if (owner && owner !== 'select') return

      const serviceRunning = selectService.isListening()

      if (this.combinedActiveLayers.length === 0) {
        if (serviceRunning) selectService.disable()
        return
      }

      if (serviceRunning) {
        selectService.setActiveLayers(this.combinedActiveLayers)
        return
      }

      const map = mapService.get()
      if (!map) return
      selectService.init(map)
      selectService.setActiveLayers(this.combinedActiveLayers)
      selectService.enablePointSelection()
    }
  },
  render() {
    return null
  }
}
</script>
